"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function parseSelectorFiltersFactory(processRawSelectorFilters, splitSelectorFilter) {
  return function (url) {
    var filterDivider = /[\s]+from[\s]+(?!.*from)/;

    if (!filterDivider.test(url)) {
      return [];
    }

    var selectorFiltersMatch = url.split(filterDivider)[0].match(/{([\s\S]*)}/);

    if (!selectorFiltersMatch) {
      return [];
    }

    var rawSelectorFilters = selectorFiltersMatch[1].split(",").map(function (x) {
      return splitSelectorFilter(x.trim());
    });
    return processRawSelectorFilters(rawSelectorFilters);
  };
}

exports.parseSelectorFiltersFactory = parseSelectorFiltersFactory;